function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { Row } from 'reactstrap';
import { WeverCoreContext } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Autocomplete from "../../../form/autocomplete";
var SelectionListStops = function SelectionListStops(props) {
  var _currentQuestion$publ;
  var onChange = props.onChange,
    index = props.index;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    responseValue = _useState2[0],
    setResponseValue = _useState2[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var min_character_search = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.min_character_search;
  var handleChange = function handleChange(optionsToValue, options) {
    var _geojson$geometry;
    var geojson = options.value.data || null;
    var coordinate = (geojson === null || geojson === void 0 || (_geojson$geometry = geojson.geometry) === null || _geojson$geometry === void 0 ? void 0 : _geojson$geometry.coordinates) || geojson;
    var res = {
      name: options.value.name,
      coordinates: coordinate,
      id: options.value.id
    };
    onChange(responses, res, null, index);
  };

  /**
   * Initialization
   */
  useEffect(function () {
    if (responses.hasOwnProperty(currentOrder.split('.')[0])) {
      if (responses[currentOrder.split('.')[0]].hasOwnProperty(currentOrder.split('.')[1])) {
        if (responses[currentOrder.split('.')[0]][currentOrder.split('.')[1]].hasOwnProperty('responses')) {
          setResponseValue(responses[currentOrder.split('.')[0]][currentOrder.split('.')[1]].responses);
        }
      }
    }
  }, [currentOrder, responses]);
  var getValue = function getValue() {
    var _geojson$geometry2;
    var alias = currentQuestion.alias;
    if (!responseValue) {
      return null;
    }
    var geojson = responseValue["".concat(alias, "_coordinates")] || null;
    var coordinate = (geojson === null || geojson === void 0 || (_geojson$geometry2 = geojson.geometry) === null || _geojson$geometry2 === void 0 ? void 0 : _geojson$geometry2.coordinates) || geojson;
    return {
      data: coordinate,
      id: responseValue["".concat(alias, "_id")],
      alias: responseValue["".concat(alias)],
      name: responseValue["".concat(alias, "_name")][locale]
    };
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    name: "name",
    resource: "GeometryPoint",
    min_character_search: min_character_search,
    tag: "name",
    display: "name",
    onChange: handleChange,
    value: getValue()
  }));
};
SelectionListStops.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
SelectionListStops.defaultProps = {
  elements: [],
  responses: {}
};
export default SelectionListStops;